module.exports = __webpack_public_path__ + "img/mobily.2a004d28.svg";